<template>
    <div>
        <div class="row justify-content-md-center">
            <div class="col-md-6">
                <b-input-group>
                    <b-form-input
                        type="text"
                        placeholder="Busca por modelo"
                        v-model="search"
                    ></b-form-input>
                    <b-input-group-append>
                        <b-input-group-text>
                            <b-icon icon="search" />
                        </b-input-group-text>
                    </b-input-group-append>
                </b-input-group>
                <div class="mt-4 mb-2">
                    <div v-if="loading" style="text-align: center;">
                        <b-spinner label="Loading..."></b-spinner>
                    </div>
                    <div class="row">
                        <div
                        v-for="(item, index) in filteredModelos"
                        :key="index"
                        :value="item.modelo"
                        class="col-md-3 col-sm-12">
                            <b-button
                           @click="set_modelo(item.modelo)"
                            id="button-models"
                            block>{{item.modelo}}</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {API_MODELOS, HEADERS} from 'providers/ApiCredentials';
import { mapFields } from "vuex-map-fields";
export default {
    data() {
        return {
            loading: true,
            search: ""
        }
    },
    computed: {
        ...mapFields("vender", [
            'selection_data.marca_id',
            'selection_data.modelo',
            'asistente_step',
            'titulo_span',
            'selection_data.marca_name',
            'form_data.modelos'
        ]),
        filteredModelos: function() {
            return this.modelos.filter((data) => {
                return data.modelo.toLowerCase().includes(this.search.toLowerCase());
            });
        }
    },
    created () {
        this.get_modelos();
    },
    methods: {
        get_modelos() {
            var queryString = window.location.search;
            var urlParams = new URLSearchParams(queryString);
            var step = urlParams.get('step');

            var data = {
                id_marca: this.marca_id
            };
            axios.get("/vender_filter_step?step="+ step +"&id_marca=" + this.marca_id).then(response => {
                var parsingModelos = _.orderBy(
                    response.data.result.modelos,
                    ["modelo"],
                    ["desc"]
                );
                var modelosFilter = [];
                parsingModelos.map(function(item) {
                    if(+item.modelo >= 2010) {
                        return modelosFilter.push(item)
                    }
                });
                this.modelos = modelosFilter;
                this.loading = false;
            });
            // axios.post(API_MODELOS,data, HEADERS).then(response => {
            //     var parsingModelos = _.orderBy(
            //         response.data.modelos,
            //         ["modelo"],
            //         ["desc"]
            //     );
            //     this.modelos = parsingModelos;
            //     this.loading = false;
            // });
        },
        set_modelo(modelo){
            this.modelo = modelo;
            this.asistente_step = 'linea';
            this.titulo_span = 'Seleccione la linea';
            window.history.replaceState(null, null, '?step=3');
        }
    },
};
</script>

<style lang="scss"></style>
